import ClientInstance from 'api/ClientInstance';
import CoreInstance from 'api/CoreInstance';
import { setHeadersWithOrgToken } from '../ApiHelpers';

interface IorgEndpoints {
  getOrganizationAsAdmin: any;
  getOrganizationAsOwner: any;
  getOrganizationAsDirector: any;
  getOrganizationAsTeacher: any;
  putOrganizationAsOwner: any;
  putOrganizationLogo: any;
  getAdminDetail: any;
  getOwnerDetail: any;
  putConfig: (body: any, token: any) => any;
}

const orgEndpoints: IorgEndpoints = {
  getOrganizationAsAdmin: () => ClientInstance.get('/organizations/admins/organization'),
  getOrganizationAsOwner: () => ClientInstance.get('/organizations/owners/organization'),
  getOrganizationAsDirector: () => ClientInstance.get('/organizations/shared/organization'),
  getOrganizationAsTeacher: () => ClientInstance.get('/centers/teachers/organization'),
  putOrganizationAsOwner: (body: any) => ClientInstance.put('/organizations/owners/organization', body),
  putOrganizationLogo: (body: any) => ClientInstance.put('/organizations/shared/organization/add_logo', body),
  getAdminDetail: (adminId: number) => ClientInstance.get(`/organizations/shared/admins/${adminId}`),
  getOwnerDetail: () => ClientInstance.get('/organizations/owners/owner'),
  putConfig: (body: any, token = null) => CoreInstance.put('/organizations/organization/organization_configuration', body, token ? setHeadersWithOrgToken(token) : {}),
};

export default orgEndpoints;
